import { SvgIcon, SvgIconProps } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export const LabelIcon = ({
  color = RoutalPalette.grey1,
  ...props
}: { color?: string } & Omit<SvgIconProps, `color`>) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16.1 12.95" style={{ width: `16px`, height: `16px`, color, ...props.style }}>
      <g>
        <path d="M10.84,12.84H1.28c-.34,0-.65-.19-.81-.49-.16-.3-.13-.67.07-.94l3.5-4.93L.54,1.55c-.2-.28-.22-.64-.07-.94.16-.3.47-.49.81-.49h9.56c.29,0,.57.14.74.37l3.99,5.46c.24.32.24.75,0,1.08l-3.99,5.45c-.17.23-.45.37-.73.37ZM1.45,11.84h9.34l3.93-5.36-3.95-5.41-9.31.04,3.44,4.84c.22.32.22.74,0,1.05l-3.44,4.84ZM1.28,1.11h0Z" />
      </g>
    </SvgIcon>
  );
};
